const html = document.querySelector("html");
const body = document.querySelector(".body");
const overlay = document.querySelector(".overlay");

//====== Registerd ScrollTrigger Plugin ==========
gsap.registerPlugin(ScrollTrigger);

function hideLoader(){
  tl.to(".loader-upper",{
      y:"-100%",
      duration:0.8,
      ease: "sine.inOut",
  })
  tl.to(".loader-inner",{
      x:"100%",
      duration:0.8,
      ease: "sine.inOut",
  }, "-=0.15")
}

//========= LENIS START =========
const lenis = new Lenis({
  duration: 1,
  easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
  infinite: false,
  syncTouch:true, // enable sync for touch devices
  smoothTouch: true, // enable smooth touch -> allow mobile scroll
});

function raf(time){
  lenis.raf(time);
  ScrollTrigger.update();
  requestAnimationFrame(raf);
}
requestAnimationFrame(raf);
//========= LENIS END =========

//======= LENIS SCROLL CONTROL =========
// let isOpened = false;
function stopLenisScroll(state = false){
  // isOpened = !isOpened;
  state ? lenis.stop() : lenis.start() 
}

//========= SCROLL & NAVBAR TOGGLE START =========
const headerBottom = document.querySelector(".header-bottom");

let prevScrollPos = 0;
const scrollThreshold = 10;  // Prevents accidental small scroll triggers
function checkScroll(){
  // let scrollTop = lenis.scroll || document.documentElement.scrollTop;
  let scrollTop = (typeof lenis?.scroll === "number") ? lenis.scroll : (document.documentElement.scrollTop || window.scrollY);
  if(scrollTop > prevScrollPos && scrollTop > scrollThreshold){
    // Scrolling down
    headerBottom.classList.add("sticky");
  }else if(scrollTop <= 0){
    headerBottom?.classList.remove("sticky");
  }
  prevScrollPos = Math.max(0, scrollTop); // Update previous scroll position
}
//========= SCROLL & NAVBAR TOGGLE END =========


//======= ACTIVE NAVIGATION LINK START =========
// const windowPathname = window?.location?.pathname;
// const navLinks = document.querySelectorAll(".navbar__link");

// navLinks.forEach(link =>{
//  const navLinkPathname = new URL(link.href, window.location.origin).pathname;
//  const isActiveLink = windowPathname === navLinkPathname || (windowPathname === "/index.html" && navLinkPathname === "/")
//   link.classList.toggle("active", isActiveLink);
// });

function normalizePath(path) {
  // Remove trailing slash if not the root
  if (path !== "/" && path.endsWith("/")) path = path.slice(0, -1);
  // Treat /index.html same as /
  if (path === "/index.html") path = "/";
  return path;
}

const currentPath = normalizePath(window.location.pathname);
const navLinks = document.querySelectorAll(".navbar__link");
navLinks.forEach(link => {
  try {
    const linkPath = normalizePath(new URL(link.href, window.location.origin).pathname);
    const isActive = currentPath === linkPath;
    link.classList.toggle("active", isActive);
  } catch (e) {
    // Skip if invalid URL (e.g., mailto:, tel:)
    console.warn("Invalid navbar link:", link.href);
  }
});
//======= ACTIVE NAVIGATION LINK END =========

//======= BANNER CONTENT ANIMATION START =========
function bannerContentsAnimation(){
  const tl = gsap.timeline();
  // Header Animation Start
  tl.from([".header__logo", ".header-btn"], {
    opacity: 0,
    y: 50,
    delay: 0.6,
    duration: 1,
    stagger:0.2,
    ease: "expo.inOut",
  });
  tl.from(".navbar__link", {
      opacity:0, 
      duration:0.8,
      stagger:0.1,
      delay:-1.5,
      ease:"power4.in",
    }
  );
  tl.from(".header-flex", {
    opacity:0,
    duration:1,
    stagger:0.1,
    delay:-1.5,
    ease:"power4.in"
  })
  // Header Animation End

  tl.from(".banner-title", {
    opacity: 0,
    duration: 1,
    // y: 50,
    delay: -1.5,
    stagger:0.1,
    ease: "power2.out",
  });
  const heroSubTitle = document.querySelectorAll(".banner-subtitle");
  heroSubTitle && tl.from(heroSubTitle, {
    opacity: 0,
    duration: 1,
    y: 50,
    delay: -1.25,
    stagger:0.12,
    ease: "power4.out",
  });

  const heroBtns = document.querySelectorAll(".banner-btn");
  heroBtns && tl.from(heroBtns, {
    opacity: 0,
    duration: 1,
    y: 50,
    delay: -1.5,
    stagger:0.1,
    ease: "power4.out",
  });

  const bigHeading = document.querySelector(".big-heading")
  bigHeading && tl.from(bigHeading, {
    opacity: 0,
    duration: 1,
    delay: -2.5,
    ease: "power4.in",
  });

  tl.from(".banner-bottom-wrapper",{
    opacity:0,
    duration:1,
    delay:-1.85,
    ease:"power4.in"
  })

  tl.from(".cta-link",{
    opacity:0,
    y:30,
    delay:-1.5,
    duration:1,
    stagger:0.2,
    ease:"power4.inOut"
  })

  const bannerImage = document.querySelectorAll(".hero-image");
  bannerImage && tl.from(bannerImage, {
    opacity: 0,
    // y: 30,
    duration: 1,
    delay: -2.5,
    stagger:0.1,
    ease:"power4.in",
  });
}
//======= BANNER CONTENT ANIMATION END =========

//====== TOGGLE MOBILE SUBMENU START ==========
const mobileMenuLinks = document.querySelectorAll(".mobile-menu__item");
const mobileMenuLinksArr = Array.from(mobileMenuLinks);
const hamburgerBtn = document.getElementById("hamburger-btn");
const backMenuBtn = document.getElementById("arrow-back-btn");
const mobileSubmenus = document.querySelectorAll(".mobileSubmenu");
const mobileMenuOverlays = document.querySelectorAll(".mobile-menu-overlay");
const searchBtnContainer = document.getElementById("search-box-container");
const searchBtns = document.querySelectorAll(".search-icon");
const closeBtn = document.getElementById("close-popup-btn");

const tl = gsap.timeline();
hamburgerBtn && hamburgerBtn.addEventListener('click', () => {
  gsap.fromTo(".aside-mobile", 
    {
      opacity:0,
      x:"-100%",

    },{
      opacity:1,
      x:0,
      duration:0.8,
      ease:"power3.inOut"
    }
  );
  gsap.fromTo(".overlay", 
    {
      opacity:0,
      x:"-100%",
    },{
      opacity:1,
      x:0,
      duration:0.65,
      delay:0.25,
      ease:"power4.out"
    }
  )
  
  tl.fromTo(".close-menu-btn", 
    {
     opacity:0,
     duration:0.6,
   },{
    opacity:1,
    delay:0.02,
    ease:"power3.inOut",
   }
  )
  mobileMenuLinksArr.forEach((mobileLink)=>{
    gsap.fromTo(mobileLink,
      {
        opacity:0,
        y:60,
      },{
        opacity:1,
        y:0,
        duration:1.2,
        stagger:0.5,
        ease:"power3.inOut"
      }
    );
  });

  tl.fromTo(".socials__item", 
    {
      opacity:0,
      x:-100,
    },{
      opacity:1,
      x:0,
      stagger:0.02,
      delay:-0.1,
      duration:0.8,
      ease:"power3.inOut",
    }
  )
  overlay?.classList.add("show");
  stopLenisScroll(true);
});

const closeMenuBtn = document.querySelector("#close-menu-btn");
closeMenuBtn && closeMenuBtn.addEventListener("click", function(){
  overlay.classList.remove("show");
  tl.fromTo(".socials__item", 
    {
      opacity:1,
      x:0,
      stagger:0.02,
      delay:-0.1,
      duration:1,
      ease:"power3.inOut",
    },{
      opacity:0,
      x:-100,
    }
  )
  mobileMenuLinksArr.forEach((mobileLink)=>{
    gsap.fromTo(mobileLink,
      {
          opacity:1,
          y:0,
          duration:1.2,
          stagger:0.5,
          ease:"power3.inOut"
      },{
          opacity:0,
          y:60,
      }
     );
   });
  tl.fromTo(".close-menu-btn", 
    {
     opacity:1,
     duration:0.6,
     delay:0.02,
     ease:"power3.inOut",
    },{
     opacity:0,
    }
  )
  gsap.fromTo(".aside-mobile", 
    {
      opacity:1,
      x:0,
      duration:0.65,
      ease:"power3.inOut"
    },{
      opacity:0,
      x:"-100%",
    }
  );
  gsap.fromTo(".overlay", 
    {
      opacity:1,
      x:0,
      duration:0.65,
      delay:-0.125,
      ease:"power4.out"
    },{
      opacity:0,
      x:"-100%",
    }
  )
  setTimeout(() => {
    // ensure overlay is removed after animation
    overlay?.classList.remove("show");
    stopLenisScroll(false); 
  }, 300);
  // stopLenisScroll(false);  
});

$(".overlay").on("click", function(){
  gsap.fromTo(".aside-mobile", 
    {
      opacity:1,
      x:0,
      duration:0.65,
      ease:"power3.inOut"
    },{
      opacity:0,
      x:"-100%",
    }
  );
  gsap.fromTo(".overlay", 
    {
      opacity:1,
      x:0,
      duration:0.65,
      delay:-0.125,
      ease:"power4.out"
    },{
      opacity:0,
      x:"-100%",
    }
  )
  overlay.classList.remove("show");
  stopLenisScroll(false);
});

// Ensure elements exist before adding event listeners
if(mobileSubmenus && mobileMenuOverlays){
  mobileSubmenus.forEach(function(mobileSubmenu, index){
    const mobileMenuOverlay = mobileMenuOverlays[index];
    mobileSubmenu.addEventListener("click", (i) => {
        mobileMenuOverlay.classList.add("show");
        gsap.fromTo([".mobile-menu-overlay-wrapper" , ".mobile-menu__link"], 
        {
            opacity:0,
            y:30,          
        },{
            opacity:1,
            y:0,
            duration:1,
            delay:-1,
            stagger:0.1,
            ease:"power4.out"
        });      
    });

    mobileMenuOverlay.querySelector("#arrow-back-btn").addEventListener("click", () => {
      mobileMenuOverlay.classList.remove("show");
    });

    // backMenuBtn.addEventListener("click", () => mobileMenuOverlays[index].classList.remove("show"));
  })
}
//====== TOGGLE MOBILE SUBMENU END ==========
function searchContentAnimation() {
  const tl = gsap.timeline();

  tl.fromTo(".search-form",
    { opacity: 0, },
    { opacity: 1, duration: 0.76, delay: -0.5, ease: "power3.out" }
  );

  tl.fromTo(".submenu__title",
    { opacity: 0 },
    { opacity: 1, duration: 1, stagger: 0.1, delay: -0.8, ease: "power4.in" }
  );

  tl.fromTo(".trendings-list li",
    { opacity: 0, y: -30 },
    { opacity: 1, y: 0, duration: 1, stagger: 0.1, delay: -1.25, ease: "power4.out" }
  );

  tl.fromTo(".swiper-trendings .products__card",
    { opacity: 0 },
    { opacity: 1, duration: 1, stagger: 0.2, delay: -1.5, ease: "power4.in" }
  );
}

// let animToggle = false;

function toggleSearch() {
  if (!searchBtnContainer) return;
  const willShow = !searchBtnContainer.classList.contains("show");
  searchBtnContainer.classList.toggle("show");
  if (willShow) {
    searchContentAnimation();
    stopLenisScroll(true)
  } else {
    stopLenisScroll(false)
  }
}

if(searchBtns && searchBtnContainer) {
  searchBtns.forEach((searchBtn) => {
    searchBtn.addEventListener("click", toggleSearch);
  });
  closeBtn && closeBtn.addEventListener("click", toggleSearch);
}

//======== ACCORDION TOGGLE START ========
let content;
function toggleAccordion(element){ 
  element.classList.toggle("is-open");
  content = element.nextElementSibling;
  if(content){
    const isOpening = content.style.maxHeight;
    content.style.maxHeight = isOpening ? null : `${content.scrollHeight}px`;
    gsap.fromTo(content.children, 
      { opacity: 0, y:50 },
      { opacity: 1, y:0, duration:0.85, stagger:0.1, ease:"power3.out"}
    );
  }
}

const accordionBtns = document.querySelectorAll(".accordion-title");
accordionBtns && accordionBtns.forEach((accordion) => {
  accordion.addEventListener("click",function (e){
    e.stopPropagation();
    toggleAccordion(accordion);
    accordionBtns.forEach(otherAccordion => {
      if(otherAccordion !== accordion) {
        otherAccordion.classList.remove("is-open");
        otherAccordion.nextElementSibling.style.maxHeight = null;
      }
    });
  });
});

const mobileSubmenuAccordions = document.querySelectorAll(".mobile-submenu");
mobileSubmenuAccordions && mobileSubmenuAccordions.forEach(function(accordionItem){
  accordionItem.addEventListener("click", function(){
    toggleAccordion(this);
     mobileSubmenuAccordions.forEach(otherAccordion => {
      if(otherAccordion !== accordionItem) {
        otherAccordion.classList.remove("is-open");
        otherAccordion.nextElementSibling.style.maxHeight = null;
      }
    });
  });
})
//======== ACCORDION TOGGLE END ========


const filterActionBtns = document.querySelectorAll(".filterAction-btn");
const filterSidebar = document.getElementById('filterSidebar');
const sortSidebar = document.getElementById('sortSidebar');
const overlay2 = document.querySelector(".overlay2")

filterActionBtns && filterActionBtns.forEach(function(filterBtn){
  filterBtn.addEventListener("click", function(e){
    const type = e.target.id;
     if (type === "filter-btn") {
      filterSidebar?.classList.add("opened");
    } else if (type === "sort-btn") {
      sortSidebar?.classList.add("opened");
    }
   overlay2?.classList.add("show"); 
    stopLenisScroll(true); 
  })
});

function closeSidebar(){
  filterSidebar?.classList.remove("opened");
  sortSidebar?.classList.remove("opened");
  overlay2?.classList.remove("show");
  stopLenisScroll(false); 
}

$(".overlay2").on("click", closeSidebar);


//======= FLOATING INPUT LABLE START ======
document.querySelectorAll(".form__control").forEach((input) => {
  input.addEventListener("focus", () => input.nextElementSibling.classList.add("focused"))
  input.addEventListener("blur", () => input.nextElementSibling.classList.toggle("focused", input.value !== ""));
}); 
//======= FLOATING INPUT LABLE END ======


//===== ENABLE/DISABLE SUBMIT BUTTON START =======
const inputCheckbox = document.getElementById("agree-consent");
inputCheckbox && inputCheckbox.addEventListener("change", function() {
  const submitBtn = document.getElementById("submit-btn");
  this.checked ? submitBtn?.classList.remove("disabled") : submitBtn?.classList.add("disabled");
});
//===== ENABLE/DISABLE SUBMIT BUTTON END ======

// ==== FILE UPLOAD SCRIPT STARTS HERE ======
const fileInput = document.getElementById("artwork-input");
const fileInfo = document.getElementById("fileInfo");
const filePreview = document.getElementById("filePreview");
const dropZone = document.getElementById("dropZone");
const removeBtn = document.getElementById("removeBtn");

// Function to select handle file
function handleFile(file){
  if(file){
    const maxSize = 10 * 1024 * 1024;
    if(file.size > maxSize){
      alert("File size exceeds 10 MB. Please upload a smaller file.");
      resetUpload();
      return;
    }
    fileInfo.textContent = `Selected File: ${file.name}`;
    removeBtn.style.display = "inline-block";
    if(file.type.startsWith("image/")){
      const reader = new FileReader();
      reader.onload = function(e){
        if(filePreview){
          filePreview.src = e.target.result;
          filePreview.style.display = "block";
        }
      }
      reader.readAsDataURL(file);
    } else{
      filePreview && (filePreview.style.display = "none"); // Hide if not image
    }
  }
}

// Reset Function
function resetUpload(){
  if(fileInput) fileInput.value = "";
  if(fileInfo) fileInfo.textContent = "";
  if(filePreview) filePreview.style.display = "none";
  if(removeBtn) removeBtn.style.display = "none";
}

// File Input Chnage
fileInput && fileInput.addEventListener("change", function(){
  handleFile(this.files[0]);
});

// Drag & Drop Events
if(dropZone){
  dropZone.addEventListener("dragover", (e)=>{
    e.preventDefault();
    dropZone.classList.add("dragover");
  });

  dropZone.addEventListener("dragleave", (e) => {
    dropZone.classList.remove("dragover");
  });
  
  dropZone.addEventListener("drop", (e)=>{
    e.preventDefault();
    dropZone.classList.remove("dragover");
  
    if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length > 0){
      if(fileInput) fileInput.files = e.dataTransfer.files; // Assign drop file
      handleFile(e.dataTransfer.files[0]);
    }
  });
}

// Remove File
removeBtn && removeBtn.addEventListener("click", resetUpload);

// ==== FILE UPLOAD SCRIPT STARTS END ======

// JavaScript for lazy loading background images start
let lazyBackgrounds = [].slice.call(document.querySelectorAll("[data-bg]"));

if("IntersectionObserver" in window){
  const lazyBackgroundObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if(entry.isIntersecting){
        let lazyBackground = entry.target;
        let imgUrl = lazyBackground.getAttribute("data-bg");
        if(entry.target.classList.contains("banner-container")){
          let linearGredient = "linear-gradient(to bottom, rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.45))";
          lazyBackground.style.backgroundImage = `${linearGredient}, url("${imgUrl}")`;
          lazyBackground.style.backgroundImage = `url("${imgUrl}")`;
        }else{
          lazyBackground.style.backgroundImage = `url("${imgUrl}")`;
        }
        lazyBackground.classList.remove("lazy");
        lazyBackgroundObserver.unobserve(lazyBackground);
      }
    });
  });

  lazyBackgrounds.forEach((lazyBackground) =>{
    lazyBackgroundObserver.observe(lazyBackground);
  });
}
// JavaScript for lazy loading background images End

// ==== Toggle Code Input  Start ========
const codeBtn = document.getElementById("code-label");
codeBtn && codeBtn.addEventListener("click", function(e){
  this.classList.toggle("show");
  document.querySelector(".code-input")?.classList.toggle("show");
});


const menuItems = document.querySelectorAll('.menu-item');
menuItems && menuItems.forEach(item => {
  item.addEventListener('click', function () {
    // Close other dropdowns
    menuItems.forEach(i => {
      if (i !== item) {
        i.classList.remove('active')
      };
    });

    // Toggle current dropdown
    this.classList.toggle('active');
  });
});

// Close dropdown on outside click
window.addEventListener('click', (e) => {
  if (!e.target.closest('.menu-item')) {
    menuItems.forEach(drop => drop.classList.remove('active'));
  }
});


// Tab Switching
const tabButtons = document.querySelectorAll('.tab-btn');
const tabContents = document.querySelectorAll('.tab-content');

tabButtons && tabButtons.forEach(btn => {
  btn.addEventListener('click', () => {
    // Remove active classes
    tabButtons.forEach(b => b.classList.remove('active'));
    tabContents.forEach(c => c.classList.remove('active'));

    // Add active to clicked tab
    btn.classList.add('active');
    const targetContent = document.getElementById(btn.dataset.tab);

    // Add active class for visibility
    targetContent.classList.add('active');

    // Animate with GSAP
    gsap.fromTo(targetContent, 
      { opacity: 0,  }, 
      { opacity: 1, duration: 0.3, ease: "power4.out" }
    );
  });
});

// Accordion Toggle
document.querySelectorAll('.accordion-header').forEach(header => {
  header.addEventListener('click', () => {
    const content = header.nextElementSibling;
    const isActive = content.classList.contains('active');
    document.querySelectorAll('.accordion-content').forEach(c => c.classList.remove('active'));
    document.querySelectorAll('.accordion-header span').forEach(span => span.textContent = '+');
    if (!isActive) {
      content.classList.add('active');
      header.querySelector('span').textContent = '-';
    }
  });
});


// Products Colors Options
const circles = document.querySelectorAll('.color-circle');
circles && circles.forEach(circle => {
  const colorCode =  circle?.getAttribute("data-color");
  if(colorCode) circle.style.backgroundColor = colorCode;
  circle.addEventListener('click', function(){
    circles.forEach(c => {
      c.classList.remove('selected');
      c.style.removeProperty("--border-color")
    });
    this.style.setProperty('--border-color', colorCode || "");
    this.classList.add('selected');
  });
});


// === Swipers ===
const swipers = document.querySelectorAll(".swiper-products");
swipers.forEach((swiperContainer)=>{
  const swiperId = swiperContainer.dataset.swiperId;
  const controlWrapper = document.querySelector(`.swiper-controls[data-swiper-id="${swiperId}"]`);
  const swiper = new Swiper(swiperContainer, {
    slidesPerView:1.1,
    spaceBetween:16,
    loop:true,
    navigation:{
      prevEl:controlWrapper?.querySelector(".swiper-btn-prev"),
      nextEl:controlWrapper?.querySelector(".swiper-btn-next"),
    },
    breakpoints:{
      576:{ slidesPerView: 2.15, spaceBetween: 20 },
      768:{ slidesPerView:3.15, spaceBetween: 24 },
      992:{ slidesPerView:3.25, spaceBetween: 28 },
      1200:{ slidesPerView:4, spaceBetween:32 }
    }
  });
});

const swiper2 = new Swiper(".swiper-trendings", {
  slidesPerView:2.15,
  spaceBetween:16,
  loop:true,
  navigation:{ prevEl:"#swiper-prev", nextEl:"#swiper-next" },
  breakpoints:{
    768:{ slidesPerView:3.15, spaceBetween: 24 },
    1680:{ slidesPerView:4.25, spaceBetween: 28 },
  }
});

const swiperHeader = new Swiper(".swiper-hero-banner", {
  slidesPerView:1,
  spaceBetween:16,
  loop:true,
  autoplay: { delay: 5000, disableOnInteraction: false },
});

//====== ANIMATION SCRIPT START =========
const textContainers = gsap.utils.toArray(".fade-up");
textContainers.forEach((textContainer, i) => {
  const anim = gsap.fromTo(textContainer,
    { opacity: 0, y: 50 },
    { duration: 1, opacity: 1, y: 0 }
  );
  ScrollTrigger.create({
    trigger: textContainer,
    animation: anim,
    toggleActions: "play",
    once: true,
    duration: 1,
    stagger:0.2,
    ease:"power4.inOut",
  });
});

const fadeIn = gsap.utils.toArray(".fade-in");
fadeIn.forEach((mainContent, i) => {
  const anim = gsap.fromTo(
    mainContent,
    { opacity: 0 },
    { opacity: 1, duration: 1}
  );
  ScrollTrigger.create({
    trigger: mainContent,
    animation: anim,
    toggleActions: "play",
    once: true,
    duration: 1,
    ease: "power4.in",
  });
});
//====== ANIMATION SCRIPT END =========


window.addEventListener("load",()=>{
  hideLoader();
  bannerContentsAnimation();
});

// Lenis scroll event
const onLenisScroll =()=>{
  checkScroll();
  ScrollTrigger.update();
}

lenis.on('scroll', onLenisScroll);

// Sync Lenis with GSAP
// gsap.ticker.add((time)=>{
//   lenis.raf(time * 1000);
// });

// Disable GSAP lag smoothing for better performance
gsap.ticker.lagSmoothing(0);
